<template>
  <div class="list">
    <ul>
      <li v-for="(item, index) in list" @click="changeHandler(index)">
        <item :class="{ active: isActive == index }" :data="item"></item>
      </li>
      <li @click="changeHandler(defaultIndex)">
        <default-item
          :class="{ active: isActive == defaultIndex }"
        ></default-item>
      </li>
    </ul>
    <div class="loading" v-if="!isEnd && goodsId">
      <img src="/images/goods/topic3.png" alt="" />
    </div>
  </div>
</template>

<script>
import { ListItem, DefaultItem } from '@/components/ticket'
export default {
  components: { Item: ListItem, DefaultItem },
  data() {
    return {
      isActive: 0,
      pageNo: 1,
      pageSize: 10,
      goodsId: this.$route.query.goodsId,
      isEnd: false,
      list: []
    }
  },
  created() {
    this.getListData()
  },
  mounted() {
    let box = document.querySelector('.loading')
    let observer = new IntersectionObserver(entries => {
      entries.forEach(item => {
        if (item.isIntersecting) {
          this.getListData()
        }
      })
    })
    observer.observe(box)
  },
  methods: {
    getListData() {
      this.$api
        .payment_v1_ticket_record_list_get({ params: { status: 1 } })
        .then(e => {
          // this.list = e.content || []
          this.list = this.list.concat(e.content)
          this.pageNo++
          if (this.list.length == e.total) {
            this.isEnd = true
          }
        })
    },
    changeHandler(index) {
      this.isActive = index
    }
  },
  computed: {
    defaultIndex() {
      return this.list.length > 0 ? this.list.length + 1 : 0
    }
  }
}
</script>

<style scoped>
.list {
  padding-top: 16px;
  background: #f7f7f7;
  min-height: 100vh;
}
</style>
